import { render, staticRenderFns } from "./AnalisisTienda.vue?vue&type=template&id=2955f01f&"
import script from "./AnalisisTienda.vue?vue&type=script&lang=js&"
export * from "./AnalisisTienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports